import Styles from './ImageContent.module.scss'
import { ChatImageContent } from 'api/clients/ChatClient'

interface ImageContentProps {
  content: ChatImageContent
}

export const ImageContent = ({ content }: ImageContentProps) => {
  return (
    <div className={Styles.imageContent}>
      <img src={content.image_url} alt="Attached content" />
    </div>
  )
}
